module.exports = "/_next/static/images/SegmentOgImage-50313581c7e6a8554429b3a63c98a809.jpg";